import React from 'react';
import PropTypes from 'prop-types';

import { Stack, Thumbnail, DropZone, Caption, Card, Icon, Button, Banner } from '@shopify/polaris';
import ImageStackItem from '@presentational/ImageStackItem';

const propTypes = {
  onDrop: PropTypes.func.isRequired,
  files: PropTypes.array,
  previewSize: PropTypes.oneOf(["small", "medium"]).isRequired,
  readOnly: PropTypes.bool,
  title: PropTypes.string,
  error: PropTypes.string,
  // uploadHelp: PropTypes.func, 

  dropZoneProps: PropTypes.object,
}

const defaultProps = {
  files: [],
  title: PropTypes.string.isRequired,
  actionTitle: PropTypes.string,
  previewSize: "small",
  readOnly: false,
  dropZoneProps: {}
}

class FileDropZone extends React.PureComponent {
  state = {
    openFileDialog: false,
  }
  // onDrop = (files, acceptedFiles, rejectedFiles) => {
    // this.setState({ files: [...this.props.files, ...acceptedFiles] });
  // }
  render() {
    const {files, uploadHelp, error, title } = this.props;
    const { openFileDialog } = this.state;
    // const fileUpload = !files.length && ( (uploadHelp && uploadHelp() ) || <DropZone.FileUpload />);
    const fileUpload = uploadHelp && uploadHelp() || <DropZone.FileUpload />;
    
    return (
      <div>
        { !!error &&
          <Banner
            title={ title }
            status="critical"
          >
            <p>
              { error }
            </p>
          </Banner>
        }
        <DropZone
          disabled={ this.props.readOnly }
          onDrop={ this.props.onDrop }
          openFileDialog={ openFileDialog }
          onFileDialogClose={() => {
            this.setState({ openFileDialog: false });
          }}
          { ...this.props.dropZoneProps }
        >
          <div className="p20" >
            { fileUpload } 
          </div>
        </DropZone>
      </div>
    );
  }

}


{/* Children custom render or default one */ }
// {
//   children ?
//     children
//     :
//     <div>
//       {uploadedFiles}
//       {fileUpload}
//     </div>
// }

FileDropZone.propTypes = propTypes;
FileDropZone.defaultProps = defaultProps;

export default FileDropZone;